import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  email: String = '';
  invalid: Boolean = false;
  constructor(
    public translations: TranslationService,
    public apiservice: ApiService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
  }

  submit() {
    this.invalid = false;
    if (!this.email) {
      return this.invalid = true;
    }
    this.apiservice.forgotPassword(this.email).subscribe((res: any) => {
      this.toastr.success('Email sent successfully', 'Email Sent');
    });
  }

}
